<template>
  <div class="acomodar">
    <Rotacion/>
  </div>
</template>

<script>
import Rotacion from '@/components/ModTecnologia/RotacionDispositivo/Rotacion.vue';
export default {
  name: 'CopiasRotacionEquipo',
  components:{
    Rotacion
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  created(){
    this.cambiarEstadoNavbar()
  },

   methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>
